<template>
  <div class="page-deblock container">
    <div class="side">

    </div>
    <div class="main">
      <ul class="clearfix">
        <li
          class="tab-item"
          :class="index==showIndex?'selected':''"
          v-for="(phone, index) in phones"
          :key="index"
          @click="showPhone(index)">{{phone.name}}</li>
      </ul>
    </div>
    <div class="phones-content">
      <div
        class="phone-cont"
        v-if="showIndex == pindex"
        v-for="(phone, pindex) in phones"
        :key="pindex"
      >
        <div class="swiper-box">
          <div class="swiper-container deblock-swiper-container" v-swiper:swiper="swiperOption" :data-index="pindex">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in phone.imgUrls" :key="index+'slide'+pindex">
                <img :src="item.url">
              </div>
            </div>
          </div>
        </div>
        <div class="pagination clearfix" v-if="showIndex == index" v-for="(phone, index) in phones" :key="index">
          <p v-if="index==pageIndex" class="step" v-for="(item, index) in phone.imgUrls" :key="'p1' + index">Step{{index+1}}</p>
          <p v-if="index==pageIndex" class="txt" v-for="(item, index) in phone.imgUrls" :key="'p2' + index">{{item.txt}}</p>
          <div class="pageNum">
            <span
              @click="showPage(index)"
              :class="index==pageIndex?'show':''"
              v-for="(item, index) in phone.imgUrls"
              :key="'span' + index">{{index+1}}</span>
          </div>
          <div class="footer-tip">
            <p v-if="showIndex == 0">注：以上教程为IOS 10.0以上版本</p>
            <p v-else>注：以上教程为Android 7.0 版本</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

if (process.env.VUE_ENV !== 'server') {
  require('swiper/dist/css/swiper.css');
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
  Vue.use(VueAwesomeSwiper);
}

let phones = [
  {
    name: '苹果账号',
    phone: 'apple',
    imgUrls: [
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-1.png', txt: '选择【设置】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-2.png', txt: '点击最上方的【账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-3.png', txt: '点击【退出登录】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-4.png', txt: '输入Apple ID密码，点击【关闭】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-5.png', txt: '在设置里点击【触控ID与密码】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-6.png', txt: '输入【开机密码】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-7.png', txt: '点击【关闭密码】' },
      { url: 'https://s1.huishoubao.com/static/m/common/iphone-8.png', txt: '点击【关闭】' }
    ]
  },
  {
    name: '三星账号',
    phone: 'sanxing',
    imgUrls: [
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-1.png', txt: '选择【设置】' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-2.png', txt: '点击【云和账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-3.png', txt: '点击【账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-5.png', txt: '点击【三星账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-6.png', txt: '选择右上角更多' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-7.png', txt: '点击【删除账户】' },
      { url: 'https://s1.huishoubao.com/static/m/common/sanxing-8.png', txt: '点击【确定】完成' }
    ]
  },
  {
    name: '小米账号',
    phone: 'xiaomi',
    imgUrls: [
      { url: 'https://s1.huishoubao.com/static/m/common/xiaomi-1.png', txt: '选择【设置】' },
      { url: 'https://s1.huishoubao.com/static/m/common/xiaomi-2.png', txt: '点击【小米账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/xiaomi-3.png', txt: '点击【退出登录】' },
      { url: 'https://s1.huishoubao.com/static/m/common/xiaomi-4.png', txt: '点击【从手机上删除】' }
    ]
  },
  {
    name: '魅族账号',
    phone: 'meizu',
    imgUrls: [
      { url: 'https://s1.huishoubao.com/static/m/common/meizu-1.png', txt: '选择【设置】' },
      { url: 'https://s1.huishoubao.com/static/m/common/meizu-2.png', txt: '找到个人，点击【Flyme账号】' },
      { url: 'https://s1.huishoubao.com/static/m/common/meizu-3.png', txt: '点击【用户头像】' },
      { url: 'https://s1.huishoubao.com/static/m/common/meizu-4.png', txt: '点击【账号管理】' },
      { url: 'https://s1.huishoubao.com/static/m/common/meizu-5.png', txt: '点击【退出账号】' }
    ]
  }
];
export default {
  data () {
    return {
      showIndex: 0,
      pageIndex: 0,
      phones: phones,
      // swiper: null,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        preloadImages: false,
        // on: {
        //   slideChange: function () {
        //     that.pageIndex = this.activeIndex;
        //   }
        // },
        observeParents: true,
        observer: true
      }
    };
  },
  watch: {
    showIndex () {
      this.initSwiper();
    }
  },
  methods: {
    showPhone (index) {
      this.showIndex = index;
      this.pageIndex = 0;
      this.swiper.slideTo(0);
    },
    showPage (index) {
      this.pageIndex = index;
      this.swiper.slideTo(index);
    },
    initSwiper () {
      // this.$nextTick(() => {
      //   const that = this;
      //   this.swiper = new window.Swiper('.deblock-swiper-container', {
      //     on: {
      //       slideChange: function () {
      //         that.pageIndex = this.activeIndex;
      //       }
      //     }
      //   });
      // });
    }
  },
  mounted () {
    this.initSwiper();
  }
};
</script>

<style lang="postcss" scoped>
.page-deblock {
  margin-top: 20px;
  padding: 35px 0 20px 120px;
  background-color: #fff;
}

.tab-item {
  float: left;
  width:70px;
  margin-right: 60px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
  &.selected {
    position: relative;
    color: #3f4353;
    border-bottom: 2px solid #3f4353;
    &::after {}
  }
}

.phones-content {
  margin-top: 20px;
}

.swiper-box {
  position: relative;
  float: left;
  width: 341px;
  height: 639px;
  background: url(//www.huishoubao.com/static/banner/deblock/img/phone.png) no-repeat left;
}

.swiper-container {
  width: 255px;
  height: 454px;
  margin-top: 70px;
}

.swiper-slide {
  height: 100%;
  width: 100%;
}

.swiper-slide img {
  height: 100%;
  width: 100%;
}

.pagination {
  float: left;
  margin-top: 110px;
  margin-left: 30px;
   span {
    display: inline-block;
    margin-right: 10px;
    font-size: 20px;
    color: #b0b8c7;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    background-color: #ffffff;
    border: solid 1px #dfe5ef;
    cursor: pointer;
  }
  span.show {
    background-color: #fabe00;
    color: #fff;
  }
  .step {
    color: #e7eaf1;
    font-size: 42px;
    margin-bottom: 40px;
  }
  .txt {
    color: #3f4353;
    font-size: 32px;
    margin-bottom: 50px;
    margin-right: -150px;
  }
  .footer-tip {
    margin-top: 200px;
  }
}

.pageNum {
  display: flex;
  justify-content: center;
}

.phones-footer {
  p {
    color:#7c829d;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/deblock/index.vue